// extracted by mini-css-extract-plugin
module.exports = {"textInput":"_53anF","highlighted":"_1n0cT","errorHighlighted":"_2Q6As","textInput__font":"_1WDUX","textInput__spacing":"cE_iE","textInput__colors":"_1EvSw"};